export { default as CornerDialog } from './src/CornerDialog'
